import { render } from "./checkContent.vue?vue&type=template&id=caf23bde&scoped=true&ts=true"
import script from "./checkContent.vue?vue&type=script&lang=ts"
export * from "./checkContent.vue?vue&type=script&lang=ts"

import "./checkContent.vue?vue&type=style&index=0&id=caf23bde&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf23bde"]])

export default __exports__